export type Platform = "web" | "android" | "iphone" | "ipad" | "mobile" | "other";
export type TripClass = "Y" | "W" | "C" | "F";
export type ResolutionType = "10min" | "1h" | "1d" | "1m";

export const availableTripClass: TripClass[] = ["Y", "W", "C", "F"];

export const defaultHost = "www.aviasales.com";

export const marketToHostMap = new Map<string, string>([
  ["ru", "www.aviasales.ru"],
  ["az", "www.aviasales.az"],
  ["tz", "www.aviasales.co.tz"],
  ["ke", "www.aviasales.co.ke"],
  ["za", "www.aviasales.co.za"],
  ["kg", "www.aviasales.kg"],
  ["us", "www.aviasales.com"],
  ["kz", "www.aviasales.kz"],
  ["by", "www.aviasales.by"],
  ["uz", "www.aviasales.uz"],
  ["ua", "www.aviasales.ua"],
  ["nl", "www.aviasales.nl"],
  ["fr", "www.aviasales.fr"],
  ["ro", "www.aviasales.ro"],
  ["md", "www.aviasales.md"],
  ["gr", "www.aviasales.gr"],
  ["in", "www.aviasales.in"],
  ["il", "www.aviasales.co.il"],
  ["pl", "www.aviasales.pl"],
  ["at", "www.aviasales.at"],
  ["es", "www.aviasales.es"],
  ["pt", "www.aviasales.pt"],
]);

export interface Deeplink {
  url: string;
  params: Record<string, any> | null;
}
